import { withContentful } from 'src/siteBuilder/renderer/contentful/withContentful'
import { TypeDynamicContentWithoutUnresolvableLinksResponse } from 'contentful-types'
import DynamicContent, { DynamicContentProps } from './DynamicContent'
import { BlockRenderer } from 'src/siteBuilder/renderer/contentful/BlockRenderer'

const ContentfulDynamicContent = withContentful<TypeDynamicContentWithoutUnresolvableLinksResponse['fields']>(
  DynamicContent,
  {
    dynamicContent: (props): DynamicContentProps['dynamicContent'] => {
      return props?.fields?.dynamicItems?.map((item) => ({
        id: item?.fields?.id?.split(' ')?.join('-'),
        content: <BlockRenderer block={item.fields.content} />,
      }))
    },
  }
)

export default ContentfulDynamicContent
